export default {
  root: ({ instance }) => ({
    class: [
      'flex items-stretch rounded-lg h-12 border-2 transition-colors duration-500',
      { 'w-full': instance.$attrs['full-width'] },
      { 'w-full max-w-[524px]': !instance.$attrs['full-width'] },
      {
        'bg-brand-greyscale-neutral-100':
          !instance.$attrs['focused'] && !instance.$attrs['has-value'],
      },
      {
        'border-2 border-blue-400 bg-white': instance.$attrs['focused'],
      },
      {
        'border-2 border-black': instance.$attrs['has-value'] && !instance.$attrs['focused'],
      },
    ],
  }),
};
